import { ArrowDownCircleIcon } from "@heroicons/react/24/outline";
import React, { Suspense } from "react";

const AppBar = React.lazy(() => import("../components/AppBar"));

const HomePage = ({ id }) => {
  return (
    <section
      id={id}
      className="relative h-screen bg-cover bg-center flex flex-col justify-center items-center w-full landscape:pt-8"
      style={{ backgroundImage: "url('/bg-home.webp')" }}
    >
      <Suspense>
        <AppBar />
      </Suspense>
      <p className="text-white landscape:pb-1 pb-3 sm:landscape:pb-3 text-center text-balance landscape:text-sm xs:text-2xl md:landscape:text-2xl px-2">
        Welcome to Colorizon Ventures
      </p>
      <p
        className="text-white px-4 text-3xl xs:text-4xl landscape:text-3xl sm:landscape:text-5xl md:text-7xl
        lg:landscape:text-8xl font-medium mb-6 landscape:mb-2 sm:landscape:mb-6 text-balance text-center"
      >
        Where Potential Meets Action
      </p>
      <p className="text-white text-center text-balance text-xs xs:text-lg sm:landscape:text-xl landscape:text-xs md:text-2xl lg:landscape:text-2xl">
        We identify opportunities, invest in innovation, and create solutions
        that transform the world.
      </p>
      <a
        href="#about"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white flex items-center justify-center hover:text-gray-300"
      >
        <span className="mr-2">Scroll Down</span>
        <ArrowDownCircleIcon className="size-6" />
      </a>
    </section>
  );
};

export default HomePage;
